import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'dmmp-sub-event',
  templateUrl: './sub-event.component.html'
})
export class SubEventComponent implements OnInit {

  @Input() subEvent
  @Input() identifier
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter()
  todayTimestamp = Math.floor(new Date().getTime() / 1000)

  constructor() { }

  ngOnInit(): void {
  }

  showEvent(event) {
    this.eventEmitter.emit(event)
  }

}
